export enum getCheerersPeriod {
  today = "today",
  lifetime = "lifetime",
}
